import { Tooltip, Zoom } from "@mui/material";

const CustomTooltip = ({ placement = 'top', text, children }) => {
    return (
      <Tooltip title={text} placement={placement} TransitionComponent={Zoom} arrow  enterDelay={500}  componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'var(--sidebar-color)',
            fontSize: '12px'
          },
        },
      }}>
        {children}
      </Tooltip>
    );
  };
  
  export default CustomTooltip;